import { ArtifactStageType } from 'App.types';

const CI_STAGES = ['local', 'dev', 'int'];

export function artifactStageFor(stage?: string): ArtifactStageType {
  return stage && CI_STAGES.includes(stage) ? 'ci' : 'rel';
}
